import * as tslib_1 from "tslib";
import { themr } from '@nextiva/analytics-lib';
import { Button } from '@nextiva/next-ui';
import cx from 'classnames';
import * as _ from 'lodash'; // issue with running test for separate import { find } from 'lodash';

import * as React from 'react';
import MultiSelectable from '../MultiSelectable';
import SingleSelectable from '../SingleSelectable';
import Styles from "./Selectable.css";

var Selectable =
/** @class */
function (_super) {
  tslib_1.__extends(Selectable, _super);

  function Selectable() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      title: _this.props.title,
      selectedOptions: _this.props.selectedOptions,
      isDirty: {},
      errors: {}
    };

    _this.handleChangeTitle = function (_a) {
      var target = _a.target;
      var errors = _this.state.errors;

      _this.setState({
        title: target.value,
        errors: tslib_1.__assign({}, errors, {
          title: !Boolean(target.value)
        })
      });
    };

    _this.changeCategory = function (nextProps) {
      var options = _this.props.options;
      var activeCategory = _this.state.activeCategory;

      if (activeCategory) {
        var category = _.find(options, {
          id: activeCategory.id
        });

        var nextCategory = _.find(nextProps.options, {
          id: activeCategory.id
        });

        if (category && nextCategory && !_.isEqual(category, nextCategory)) {
          _this.setCategory(nextCategory);
        }
      }
    };

    _this.setCategory = function (category) {
      var activeCategory = _.cloneDeep(category);

      activeCategory.hasMore = !!category.hasMore;

      if (!category.search) {
        activeCategory.search = '';
      }

      if (!_.has(category, 'page')) {
        activeCategory.page = -1;
      }

      _this.setState({
        activeCategory: activeCategory
      });
    };

    _this.handlerClickSingleOption = function (option) {
      var _a;

      var activeCategory = _this.state.activeCategory;
      var _b = _this.props,
          togglePopover = _b.togglePopover,
          handlerSubmit = _b.handlerSubmit;

      if (activeCategory) {
        if (togglePopover) {
          togglePopover();
        }

        handlerSubmit((_a = {}, _a[activeCategory.id] = [option], _a));
      }
    };

    _this.handlerUpdateDirtyCategory = function (isDirty) {
      _this.setState({
        isDirty: isDirty
      });
    };

    _this.handlerUpdateSelected = function (selectedOptions) {
      var errors = _this.state.errors;

      var newSelectedOptions = _.omitBy(selectedOptions, _.isEmpty);

      _this.setState({
        selectedOptions: newSelectedOptions,
        errors: tslib_1.__assign({}, errors, {
          options: !Boolean(Object.keys(newSelectedOptions).length)
        })
      });
    };

    _this.handlerSubmitMultiOptions = function (event) {
      var _a;

      var _b = _this.props,
          withCategories = _b.withCategories,
          handlerSubmit = _b.handlerSubmit,
          togglePopover = _b.togglePopover;
      var _c = _this.state,
          title = _c.title,
          activeCategory = _c.activeCategory,
          selectedOptions = _c.selectedOptions,
          errors = _c.errors;
      var isSelectedOptions = Boolean(Object.keys(selectedOptions).length);

      if (title && isSelectedOptions) {
        if (togglePopover) {
          togglePopover(event);
        }

        if (withCategories) {
          handlerSubmit(selectedOptions, title);
        } else if (activeCategory) {
          var selected = selectedOptions[activeCategory.id];
          var selectedOption = Object.assign({}, selected && (_a = {}, _a[activeCategory.id] = selected, _a));
          handlerSubmit(selectedOption, title);
        }
      } else {
        _this.setState({
          errors: tslib_1.__assign({}, errors, {
            title: !title,
            options: !isSelectedOptions
          })
        });
      }
    };

    return _this;
  }

  Selectable.prototype.componentWillMount = function () {
    var _a = this.props,
        withCategories = _a.withCategories,
        options = _a.options;
    var firstCategory = options[0];

    if (!withCategories && firstCategory) {
      this.setCategory(firstCategory);
    }
  };

  Selectable.prototype.componentWillReceiveProps = function (nextProps) {
    this.changeCategory(nextProps);
  };

  Selectable.prototype.render = function () {
    var _a;

    var _b = this.props,
        async = _b.async,
        editable = _b.editable,
        options = _b.options,
        withCategories = _b.withCategories,
        beforeCategoriesList = _b.beforeCategoriesList,
        selectableType = _b.selectableType,
        togglePopover = _b.togglePopover,
        loadCategories = _b.loadCategories,
        loadOptions = _b.loadOptions,
        singleOptionComponent = _b.singleOptionComponent,
        multiOptionComponent = _b.multiOptionComponent,
        categoryComponent = _b.categoryComponent,
        submitText = _b.submitText,
        withoutControls = _b.withoutControls,
        theme = _b.theme;
    var _c = this.state,
        selectedOptions = _c.selectedOptions,
        activeCategory = _c.activeCategory,
        isDirty = _c.isDirty,
        title = _c.title,
        errors = _c.errors;
    return React.createElement("div", {
      className: cx(theme.selectableBody, (_a = {}, _a[theme.withoutControls] = withoutControls, _a[theme.activeCategory] = Boolean(activeCategory), _a))
    }, withCategories && React.createElement(SingleSelectable, {
      isCategories: true,
      async: async,
      editable: editable,
      title: title,
      options: options,
      isDirty: isDirty,
      beforeList: beforeCategoriesList,
      activeCategoryId: activeCategory && activeCategory.id,
      selectedOptions: selectedOptions,
      handleChangeTitle: this.handleChangeTitle,
      handlerClick: this.setCategory,
      loadCategories: loadCategories,
      singleOptionComponent: categoryComponent,
      isError: errors.title
    }), activeCategory && selectableType === 'single' && React.createElement(SingleSelectable, {
      async: async,
      title: activeCategory.name,
      options: activeCategory.data || [],
      activeCategoryId: activeCategory.id,
      selectedOptions: selectedOptions,
      handlerClick: this.handlerClickSingleOption,
      singleOptionComponent: singleOptionComponent,
      withoutControls: withoutControls
    }, !withoutControls && React.createElement("div", {
      className: theme.selectableControls
    }, React.createElement(Button, {
      onClick: togglePopover
    }, "Cancel"))), activeCategory && selectableType === 'multiple' && React.createElement(MultiSelectable, {
      async: async,
      title: activeCategory.name,
      isDirty: isDirty,
      options: activeCategory.data || [],
      hasMore: activeCategory.hasMore,
      search: activeCategory.search,
      page: activeCategory.page,
      activeCategoryId: activeCategory.id,
      selectedOptions: selectedOptions,
      handlerUpdateDirtyCategory: this.handlerUpdateDirtyCategory,
      handlerUpdateSelected: this.handlerUpdateSelected,
      multiOptionComponent: multiOptionComponent,
      loadOptions: loadOptions,
      error: errors.options
    }, !withoutControls && React.createElement("div", {
      className: theme.selectableControls
    }, React.createElement(Button, {
      onClick: togglePopover
    }, "Cancel"), React.createElement(Button, {
      kind: "success",
      onClick: this.handlerSubmitMultiOptions
    }, submitText))));
  };

  Selectable.defaultProps = {
    async: false,
    editable: false,
    options: [],
    selectedOptions: {},
    selectableType: 'multiple',
    withCategories: false,
    handlerSubmit: function handlerSubmit(selectedOptions) {
      console.log(selectedOptions); //eslint-disable-line
    },
    submitText: 'Submit'
  };
  return Selectable;
}(React.PureComponent);

export default themr(Selectable, Styles);